/**
 * D-068: Assembly raporu (FM-0012) dosya adından riser numarası ve dosya ailesi. Sunucu (toplu yükleme) ve tarayıcı (PDF ile
 * excel'i aynı satırda eşleme) aynı kuralı kullanır. `sokumRnBul` bu adların 43'ünden 25'ini okur (18'inde riser bulamaz):
 * "RN 015.PDF" ve "ASSEMBLY TRACE SHEET BATCH 3 RN 135.pdf" ailelerini tanımaz; o kurala dokunulmaz, bu ayrı kuraldır.
 *
 * `montajRnBul`: önce uzantı (.pdf / .xlsx; önünde boşluk olabilir), sonra sondaki kopya ekleri (" (1)", " - Copy", " - Kopya") atılır.
 * 1. Etiketli numara, üç etiketten biriyle: RISER (ardından isteğe bağlı No / No. / Number / #) · RN · tek başına duran R.
 *    Etiketin önünde harf ya da rakam olamaz ("TURN 12" RN değildir; sınır açık yazılır, alt çizgi sınırdır). Numara 1–3 hanedir,
 *    baştaki sıfırlar atılır; dört ve daha çok haneli sayıdan numara kesilmez; 0 riser değildir.
 * 2. Etiketli numaralar birden çok ve FARKLI ise null ("Riser No 106 RN 107 …"): sormak yanlış riserden güvenlidir.
 * 3. Etiketli numara yoksa tek istisna: ad "BATCH <parti>" + ayırıcı + 1–3 haneli sayı ile BİTİYORSA (ardından yalnız SLICK
 *    gelebilir) o sayı riserdir ("ASSEMBLY TRACE SHEET BATCH 3 155.pdf"). BATCH'in hemen ardındaki parti numarası hiçbir zaman
 *    riser değildir; sayının ardından nokta ve rakam geliyorsa ("… BATCH 4 25.06.2025.pdf") ad bu kalıpla bitmez, null.
 * Okunamazsa null (toplu yükleme o satırda riseri sorar). Ad tek başına güven değildir: girdi excel'inin RN alanı ayrıca denetlenir.
 */
const rnYaz = (n) => `R${String(n).padStart(3, "0")}`;
const UZANTI = /\s*\.(?:PDF|XLSX)\s*$/;
const KOPYA_EKI = /(?:\s*\(\d\)|\s+-\s+(?:COPY|KOPYA))+$/;
const ETIKETLER = [
    /(?<![A-Z0-9])RISER[\s_-]*(?:NO\.?|NUMBER|#)?[\s_:#-]*0*(\d{1,3})(?!\d)/g,
    /(?<![A-Z0-9])RN[\s_:#.-]*0*(\d{1,3})(?!\d)/g,
    /(?<![A-Z0-9])R[-_ ]?0*(\d{1,3})(?!\d)/g,
];
const PARTI_SONU = /(?<![A-Z0-9])BATCH[\s_-]*\d{1,2}[\s_-]+0*(\d{1,3})(?:[\s_-]+SLICK)?$/;
export function montajRnBul(dosyaAdi) {
    const t = (dosyaAdi ?? "").toUpperCase().replace(UZANTI, "").replace(KOPYA_EKI, "").replace(/\s+/g, " ").trim();
    const bulunan = new Set();
    for (const re of ETIKETLER)
        for (const m of t.matchAll(re))
            if (Number(m[1]) > 0)
                bulunan.add(Number(m[1]));
    if (bulunan.size > 1)
        return null;
    if (bulunan.size === 1)
        return rnYaz([...bulunan][0]);
    const p = PARTI_SONU.exec(t);
    return p && Number(p[1]) > 0 ? rnYaz(Number(p[1])) : null;
}
/**
 * Dosya adının söylediği belge ailesi. "DISASSEMBLY" sözcüğü "ASSEMBLY"yi içerdiği için ÖNCE söküm aranır.
 * - disassembly: adında söküm sözcüğü geçer (Disassembly, Dis-assembly, Dissassembly, Disassemby; söküm girdisi
 *   "R106-disassembly-input-EN.xlsx" dahil). Assembly penceresi bu dosyayı reddeder (K-E3).
 * - assembly: adında Assembly (Assemby, Asembly yazımlarıyla) ya da TRACE SHEET geçer.
 * - belirsiz: ad aile söylemez ("RN 015.PDF"). Reddedilmez: arşivdeki 43 raporun 6'sının adı böyledir.
 * Başka aileler (SURVREP, MRB) burada tanınmaz, "belirsiz" döner.
 */
export function montajDosyaAilesi(dosyaAdi) {
    const t = (dosyaAdi ?? "").toUpperCase();
    if (/DIS[\s_-]?S?AS{1,2}EMB/.test(t))
        return "disassembly";
    if (/AS{1,2}EMB|TRACE[\s_-]*SHEET/.test(t))
        return "assembly";
    return "belirsiz";
}
/** Assembly girdi excel'inin sözleşmedeki adı: "R106" (ya da "106", "r7") → "R106-assembly-input-EN.xlsx". */
export function montajGirdiAdi(rn) {
    return `${rnYaz(Number(rn.replace(/^R/i, "")))}-assembly-input-EN.xlsx`;
}
//# sourceMappingURL=montaj-rn.js.map